import { OrderBookReport } from "../../Interfaces/orderBookSamplingInterfaces";
import { CommonTableUI } from "../TableTemplate/common";
import { ITableUI } from "../TableTemplate/tableTemplate";

const OrderBookSamplingTableUI: React.FC<ITableUI<OrderBookReport>> = ({
  reports,
  onAction,
}: ITableUI<OrderBookReport>) => {
  return <CommonTableUI reports={reports} onAction={onAction} />;
};

export default OrderBookSamplingTableUI;
